import type { ManagedAgent } from "@taskin-code/contracts";
import { isCoordinator } from "@taskin-code/shared/managedAgentMode";

export function sortProjectAgents(
  agents: ReadonlyArray<ManagedAgent>,
): ReadonlyArray<ManagedAgent> {
  return agents.toSorted((left, right) =>
    left.name.localeCompare(right.name, undefined, { sensitivity: "base" }),
  );
}

export function filterCoordinators(
  agents: ReadonlyArray<ManagedAgent>,
): ReadonlyArray<ManagedAgent> {
  return agents.filter((agent) => isCoordinator(agent.mode));
}

export function projectAgentWarning(agent: ManagedAgent): string | null {
  const warnings: string[] = [];
  if (
    agent.tools.length > 0 &&
    !agent.tools.some((tool) => tool === "taskin_agents" || tool.startsWith("taskin_agents:"))
  ) {
    warnings.push("sin tools de agentes");
  }
  return warnings.length === 0 ? null : `No podrá delegar: ${warnings.join(" / ")}`;
}
